import React, { Component } from "react";
import { Modal, Table, Input } from "antd";

import { numberFormat, formatDate } from "../../util";
import { getUser } from "../../contexts/asyncContext";
import { httpGet, httpUrl } from "../../api/httpClient";
import { connect } from "react-redux";
import SelectBox from "../common/SelectBox";
import string from "../../string";

const Search = Input.Search;

class UserListModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userList: [],
      pagination: {
        current: 1,
        total: 0
      },
      searchText: "",
      searchType: "NAME",
    };
  }
  componentDidMount() {
    this.getUserList();
  }

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager
    });
    this.getUserList({ pageNum: pager.current });
  };
  
  getUserList = (params = {}) => {
    const { searchText,searchType } = this.state;
    let pageNum = params.pageNum || 1;

    httpGet(httpUrl.userList, [10, pageNum, false, searchText,searchType], {})
      .then((res) => {
        const pagination = { ...this.state.pagination };
        pagination.current = res.data.currentPage;
        pagination.total = res.data.totalCount;
        this.setState({
          userList: res.data.userList,
          pagination
        });
      })
      .catch((error) => {});
  };

  onSearch = (value) => {
    this.setState(
      {
        searchText: value
      },
      () => {
        this.getUserList();
      }
    );
  };

  render() {
    const { visible, onOk, onCancel } = this.props;
    const { searchType } = this.state;

    const memberColumns = [
      {
        title: "",
        dataIndex: "idx",
        key: "idx",
        className: "support-column-number fs-15 lh-21",
        render: (data) => <div>{numberFormat(data)}</div>
      },
      {
        title: "등록일",
        dataIndex: "createDate",
        key: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
          <div key={`createDate${index}`}>{formatDate(data)}</div>
        )
      },
      {
        title: "아이디(이메일)",
        dataIndex: "id",
        key: "id",
        // width: 80,
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => {
          return (
            <div
              key={`serial${index}`}
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() => this.props.onOk(row)}>
              {data}
            </div>
          );
        }
      },
      {
        title: "이름",
        dataIndex: "name",
        key: "name",
        // width: 80,
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => {
          return (
            <div key={`serial${index}`} className="flex-row flex-column">
              {data}
            </div>
          );
        }
      }
    ];

    return (
      <Modal
        visible={visible}
        title="회원검색"
        onText="확인"
        cancelText="취소"
        onOk={onOk}
        onCancel={onCancel}
        style={{ minWidth: "800px" }}
        footer={null}>
        <div className="flex-row flex-center flex-sb m-b-10">
          <SelectBox
            value={string.userListTypeString[searchType]}
            code={string.userListTypeCode}
            codeString={string.userListTypeString}
            onChange={(value) => {
              if (value !== searchType) {
                this.setState({
                  searchType: value,
                });
              }
            }}
            style={{ width: "100px", marginLeft: "10px" }}
          />
          <Search
            placeholder={"아이디, 이름을 입력해주세요."}
            enterButton="검색"
            allowClear
            onSearch={this.onSearch}
            style={{ width: 400 }}
          />
        </div>
        <Table
          id="member-table"
          className="flex-1"
          rowKey={(record) => record.idx}
          columns={memberColumns}
          dataSource={this.state.userList}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </Modal>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    result: state.async.fetchData
  };
};
let mapDisPatchToProps = (dispatch) => {
  return {
    getUser: ({
      pageSize,
      pageNum,
      deleted,
      searchText,
      searchType,
      startDate,
      endDate
    }) =>
      dispatch(
        getUser({
          pageSize,
          pageNum,
          deleted,
          searchText,
          searchType,
          startDate,
          endDate
        })
      )
  };
};

export default connect(mapStateToProps, mapDisPatchToProps)(UserListModal);
